<div class="d-box mt-2 border rounded p-2" *ngIf="criterion$ | async as criterion">
  <ng-container [ngSwitch]="criterion.criterionType">
    <ng-container *ngSwitchCase="'STICK'">
        <app-question-decision></app-question-decision>
    </ng-container>
    <app-criteria-decision *ngSwitchDefault></app-criteria-decision>
  </ng-container>
</div>